import axiosInstance from "auth/FetchInterceptor";
import {
  GET_ALL_MARKETING_NOI_BO,
  UPSERT_MARKETING_NOI_BO,
  DELETE_MARKETING_NOI_BO,
  GUI_THONG_BAO_MARKETING_NOI_BO,
  GET_ACTIVE_MARKETING_NOI_BO,
  GHI_LOG_MARKETING_NOI_BO,
} from "constants/ApiConstant";

const marketingNoiBoService = {};

marketingNoiBoService.getAll = function (params) {
  return axiosInstance.get(GET_ALL_MARKETING_NOI_BO, { params });
};

marketingNoiBoService.upsert = function (data) {
  return axiosInstance.post(UPSERT_MARKETING_NOI_BO, data);
};

marketingNoiBoService.delete = function (id) {
  return axiosInstance.delete(`${DELETE_MARKETING_NOI_BO}/${id}`);
};

marketingNoiBoService.guiThongBao = function (id) {
  return axiosInstance.post(`${GUI_THONG_BAO_MARKETING_NOI_BO}/${id}`);
};

marketingNoiBoService.getActiveForUser = function () {
  return axiosInstance.get(GET_ACTIVE_MARKETING_NOI_BO);
};

marketingNoiBoService.ghiLog = function (data) {
  return axiosInstance.post(GHI_LOG_MARKETING_NOI_BO, data);
};

export default marketingNoiBoService;
